import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { useMutation } from 'react-query';
import { removeFlexMatchPreferredEmployee } from 'RestAPIs/flex-match';

export type RemoveFlexMatchPreferredEmployeePayload = {
  requestId: number;
  body: {
    employeeId: number;
    bpmTaskId: string;
  };
};

const useRemoveFlexMatchPreferredEmployee = () => {
  return useMutation(
    (payload: RemoveFlexMatchPreferredEmployeePayload) =>
      removeFlexMatchPreferredEmployee(payload),
    {
      onSuccess: () => {
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useRemoveFlexMatchPreferredEmployee;
